<template>
  <div class="pulse-strength-check">
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">Is pulse strength at</div>
      <el-select
        v-close-on-zoom
        :value="state.locations"
        placeholder="Select a location"
        class="pulse-location-select"
        :disabled="readonly"
        :multiple="true"
        @input="(locations) => setLocations(locations)"
      >
        <el-option
          v-for="location in pulseLocations"
          :key="location.key"
          :label="location.label.en"
          :value="location.key"
        />
      </el-select>
      <operator-select
        :value="state.operator"
        :disabled="readonly"
        @input="(operator) => setOperator(operator)"
      />
      <el-select
        v-close-on-zoom
        class="pulse-strength-select"
        :value="state.strength"
        :disabled="readonly"
        @input="(strength) => setStrength(strength)"
      >
        <el-option
          v-for="strengthValue in strengthValues"
          :key="strengthValue"
          :label="strengthValue"
          :value="strengthValue"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import range from 'lodash/range';

import pulseLocations from '~lib/common/config/pulseLocations';
import OperatorSelect from './common/OperatorSelect.vue';

export default {
  name: 'pulse-strength-check',
  components: { OperatorSelect },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        locations: [],
        strength: 5,
        operator: 'EQUAL',
      },
      pulseLocations,
      strengthValues: range(6),
    };
  },
  mounted() {
    const data = this.getData(this.ikey);
    this.state.locations = get(data, 'ids') || [];
    this.state.operator = get(data, 'operator') || 'EQUAL';
    this.state.strength = get(data, 'value', 5);
    this.update();
  },
  methods: {
    setLocations(locations) {
      this.state.locations = locations;
      this.update();
    },
    setOperator(operator) {
      this.state.operator = operator;
      this.update();
    },
    setStrength(strength) {
      this.state.strength = strength;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'PULSE_STRENGTH',
        ids: this.state.locations,
        operator: this.state.operator,
        value: this.state.strength,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.pulse-strength-check {
  display: flex;
  align-items: center;
}
</style>